// oxlint-disable-next-line no-restricted-imports
import { createRoutePath } from "@myvp/shared/src/functions/create-route-path"
import { getRegionFromHostname } from "@myvp/shared/src/functions/get-region"
import { MyVeevaRegion } from "@myvp/study-preview/src/gql/graphql"

const globalEproPreview = createRoutePath(
  `/studio/collection/:collectionId/preview/:surveyId`
)

const getSponsorsExternalLinkFromSites = (
  routeParams: Parameters<typeof globalEproPreview>[0],
  studyRegion: MyVeevaRegion,
  location?: URL
) => {
  const url = new URL((location ?? window.location).href)

  // study-preview components that need to show this link will add the needed search params
  url.search = ""
  url.pathname = globalEproPreview(routeParams)

  // change parts of the hostname from:
  // sites => sponsors
  // sites region => study region
  {
    let hostname = url.hostname
    hostname = hostname.replace("sites", "sponsors")

    const region = getRegionFromHostname(hostname)
    if (region) {
      hostname = hostname.replace(region, studyRegion)
    }

    url.hostname = hostname
  }

  // hard code development port so this works locally.
  if (process.env.NODE_ENV === "development" && url.port) {
    url.port = "3005"
  }

  return url.href
}

export const studyPreviewRouteNames = {
  sponsors: {
    globalEproPreview,
  },
  sites: {
    getSponsorsExternalLinkFromSites,
  },
} as const
